// extracted by mini-css-extract-plugin
export default {"embedContainer":"_3e8mU_J39ot2dKNc_uNgiN","riskDetailInnerContainer":"ZgMxqciGQKc84UFvV4PpN","tabViewContainer":"_3jK9bn8ftubpIUFGYmoPgc"};